import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type { NotificationCounterStore } from '../../types';

@Injectable({ providedIn: 'root' })
export class NotificationsCounterHttpService {
  protected readonly httpApi = inject(HttpApiService);

  public fetch(): Observable<NotificationCounterStore> {
    return this.httpApi.get('tracking/notifications/counters');
  }
}
